// Environment configuration (VITE_* values are baked in at build time)
export const API_BASE_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:4009'
export const AI_API_BASE_URL = import.meta.env.VITE_AI_API_URL ?? 'http://localhost:5001'
/** Public blog origin, e.g. https://scripthill.com. Optional; enables "View on site" links. */
export const SITE_URL = (import.meta.env.VITE_SITE_URL ?? '').replace(/\/$/, '')

export function publicPostUrl(slug: string) {
  return SITE_URL ? `${SITE_URL}/posts/${slug}` : null
}
